import { connect } from 'react-redux';
import _merge from 'lodash.merge';
import WebViewComponent from './web-view.component';
import * as WebViewActions from './web-view.actions';

const mapStateToProps = (state, ownProps) => {
    //console.log("[WebView] mapStateToProps: ownProps:", ownProps);

    const props = _merge({}, state.WebView, ownProps)
    //console.log("[WebView] mapStateToProps: props:", props);
    return props;
};
const mapDispatchToProps = dispatch => {
    return {
        onReady: (medscape, tracking) => {
            dispatch(WebViewActions.ready(medscape, tracking));
        },
        onDocumentReady: (event) => {
        	dispatch(WebViewActions.onDocumentReady(event));
        },
        onWindowLoad: (event) => {
        	dispatch(WebViewActions.onWindowLoad(event));
        }

    }
};

const WebView = connect(mapStateToProps, mapDispatchToProps)(WebViewComponent);
export default WebView;